/**
 * メインアプリケーションファイル
 *
 * 概要:
 * - 本テーマは eon の 1ページ構成のみを対象とし、共通メニューや別サイト由来の演出は持たない。
 * - `#sections` があるトップページでのみ `initEonPage()` を初期化する。
 *
 * 制限事項:
 * - 404 など `.eon-front` のみ付与されたページではセクション切替を初期化しない。
 */

import '../scss/style.scss';
import { initEonPage } from './eon.js';

/**
 * JS 実行環境が自動ブラウザ（webdriver）のとき本文を表示する
 *
 * 概要:
 * - PHP 側 UA 判定のフォールバック。一般ユーザーでは webdriver は false。
 *
 * @returns {void}
 */
function applyAutomatedBrowserVisibilityFallback() {
  if (!navigator.webdriver || !document.body) {
    return;
  }

  document.body.classList.add('loading-complete', 'eon-automated-view');
}

applyAutomatedBrowserVisibilityFallback();

/**
 * 初期化
 *
 * @returns {void}
 */
function windowLoaded() {
  try {
    if (document.body.classList.contains('eon-front') && document.getElementById('sections')) {
      initEonPage();
    }
  } finally {
    document.body.classList.add('loading-complete');
  }
}

window.addEventListener('load', windowLoaded);

export {};

